module.exports = __webpack_public_path__ + "static/media/sp_repo.3e5130a3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/books/sp_repo.svg
// module id = 406
// module chunks = 0